/** Persist editor spread index in localStorage (survives refresh). Cleared on logout via `clearAuth`. */
export const EDITOR_SPREAD_STORAGE_KEY = 'editor-spread.v1'

export function readStoredSpreadIndex(): number | null {
  if (typeof window === 'undefined') return null

  try {
    const raw = localStorage.getItem(EDITOR_SPREAD_STORAGE_KEY)

    if (raw == null || raw === '') return null

    const n = JSON.parse(raw) as unknown

    if (typeof n !== 'number' || !Number.isInteger(n) || n < 0) return null

    return n
  } catch {
    return null
  }
}

export function writeStoredSpreadIndex(index: number): void {
  if (typeof window === 'undefined') return

  try {
    if (!Number.isInteger(index) || index < 0) return

    localStorage.setItem(EDITOR_SPREAD_STORAGE_KEY, JSON.stringify(index))
  } catch {
    // Quota / private mode — ignore.
  }
}

export function clearStoredSpreadIndex(): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(EDITOR_SPREAD_STORAGE_KEY)
  } catch {
    // ignore
  }
}
